/* Store */
import { useCustomerGroupsStore } from '../store/customerGroups.js';

export const useGenericAnalyticsData = () => {
  const customerGroupsStore = useCustomerGroupsStore();
  const { getCustomerGroups: customerGroups } = customerGroupsStore;

  /**
   * Generates analytics data.
   * @returns {object} - The analytics data object.
   */
  const genericAnalyticsData = () => ({
    employee_flag: customerGroups === 'US' ? 'true' : 'false',
  });

  return { genericAnalyticsData };
};

export default useGenericAnalyticsData;
